import { render, staticRenderFns } from "./DocumentPatternField.vue?vue&type=template&id=200cb1b1"
import script from "./DocumentPatternField.vue?vue&type=script&lang=js"
export * from "./DocumentPatternField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports